/**
 * Pickup Service Switch
 * Uses mock data when VITE_ENABLE_MOCK_DATA is true, otherwise real API.
 */
import config from '../config/config';

import * as realService from './pickupService';
import * as mockService from './mockPickupService';

const svc = config.features.enableMockData ? mockService : realService;

export const getPickupFolders = svc.getPickupFolders;
export const getAllPickupFolders = svc.getAllPickupFolders;
export const getPickupFolderById = svc.getPickupFolderById;
export const createPickupFolder = svc.createPickupFolder;
export const updatePickupFolder = svc.updatePickupFolder;
export const deletePickupFolder = svc.deletePickupFolder;
export const getPickupFolderFiles = svc.getPickupFolderFiles;
export const getPickupUsers = svc.getPickupUsers;
export const getPickupUserById = svc.getPickupUserById;
export const createPickupUser = svc.createPickupUser;
export const updatePickupUser = svc.updatePickupUser;
export const deletePickupUser = svc.deletePickupUser;
export const downloadPickupFile = svc.downloadPickupFile;
